<script>
  import { domainName, record, newRecordCreated } from '../stores.js';
  import DMARCSearch from './dmarcSearch.svelte';
  import DMARCResult from './dmarcResult.svelte';
  import DMARCNew from './dmarcNew.svelte';
  import Tools from '../Tools.svelte';
</script>

{#if $domainName == '' }
  <DMARCSearch />
  <Tools skip={'dmarc'} />
{:else}
  {#if $newRecordCreated }
    <DMARCNew />
  {:else}
    <DMARCResult />
  {/if}
{/if}

<style>

</style>
